export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14738.eaf4eff3.jpg";